import React, { useEffect } from "react";
import { Space, Table, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";

import {
  Document,
  Page,
  Text,
  StyleSheet,
  View,
  PDFViewer,
} from "@react-pdf/renderer";
const styles = StyleSheet.create({
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 10,
    // height: "100%",
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableColumns: {
    width: "12.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    // padding: 25,
    // paddingTop: 15,
    // paddingLeft: 15,
    // paddingRight: 15,
  },
  tableCol: {
    width: "12.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    // paddingTop: 15,
    // paddingLeft: 15,
    // paddingRight: 15,
    // padding: 25,
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
    fontSize: 8,
  },
  tableColleft: {
    width: "12.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "left",
  },
  tableCellright: {
    // margin: "auto",
    marginTop: 5,
    fontSize: 8,
    marginRight: 3,
  },
  tableCellleft: {
    marginTop: 5,
    fontSize: 8,
    marginLeft: 5,
  },
  tableColright: {
    width: "12.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "right",
  },
  tableColleft: {
    width: "12.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "left",
  },
  tableCellright: {
    // margin: "auto",
    marginTop: 5,
    fontSize: 8,
    marginRight: 3,
  },
  tableCellleft: {
    marginTop: 5,
    fontSize: 8,
    marginLeft: 5,
  },
  tableColright: {
    width: "12.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "right",
  },
});

function WeeklySpendByServiceLevel({ tableWeeklySpend, startDates, endDates }) {
  // console.log("spendss", tableWeeklySpend);
  console.log(endDates);
  const start_Date = new Date(startDates);
  const end_Date = new Date(endDates);

  const oneWeek = 7 * 24 * 60 * 60 * 1000;

  // Calculate the start and end dates for previous week and pre-previous week
  const prevWeekStartDate = new Date(start_Date.getTime() - oneWeek);
  const prevWeekEndDate = new Date(end_Date.getTime() - oneWeek);

  const prePrevWeekStartDate = new Date(start_Date.getTime() - 2 * oneWeek);
  const prePrevWeekEndDate = new Date(end_Date.getTime() - 2 * oneWeek);
  const threeweekstartDate = new Date(start_Date.getTime() - 3 * oneWeek);
  const threeweekEndDate = new Date(end_Date.getTime() - 3 * oneWeek);

  // Format the dates to strings in the desired format (DD/MM - DD/MM)
  const formatDate = (date) => {
    const day = date.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];

    // Function to add suffix to day of the month
    const addSuffix = (day) => {
      if (day > 3 && day < 21) return `${day}th`;
      switch (day % 10) {
        case 1:
          return `${day} st`;
        case 2:
          return `${day}nd`;
        case 3:
          return `${day}rd`;
        default:
          return `${day}th`;
      }
    };

    const formattedDay = addSuffix(day);

    return `${formattedDay} ${month}`;
  };
  const threeweekRange = `${formatDate(threeweekstartDate)} - ${formatDate(
    threeweekEndDate
  )}`;
  const prevWeekRange = `${formatDate(prevWeekStartDate)} - ${formatDate(
    prevWeekEndDate
  )}`;
  const prePrevWeekRange = `${formatDate(prePrevWeekStartDate)} - ${formatDate(
    prePrevWeekEndDate
  )}`;
  const currentWeekRange = `${formatDate(start_Date)}-${formatDate(end_Date)}`;
  useEffect(() => {
    console.log("spendss", tableWeeklySpend);
  }, []);
  const regions = [...new Set(tableWeeklySpend.map((item) => item.region))];
  const formatNumberWithCommas = (number) => {
    const roundedNumber = Math.round(number); // Round the number to remove floating point
    return roundedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  return (
    <div>
      {regions.map((region, index) => (
        <View style={styles.section}>
          <View style={{ flexDirection: "row", marginTop: 10 }}>
            {region === "ap-south-1" ? (
              <Text style={{ color: "#FF6A2F", fontSize: 12 }}>
                Region: {region}(Mumbai)
              </Text>
            ) : region === "ap-south-2" ? (
              <Text style={{ color: "#FF6A2F", fontSize: 12 }}>
                Region: {region}(Hyderabad)
              </Text>
            ) : region === "ap-southeast-1" ? (
              <Text style={{ color: "#FF6A2F", fontSize: 12 }}>
                Region: {region}(Singapore)
              </Text>
            ) : region === "ap-southeast-2" ? (
              <Text style={{ color: "#FF6A2F", fontSize: 12 }}>
                Region: {region}(Sydney)
              </Text>
            ) : (
              ""
            )}{" "}
          </View>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableColumns}>
                <Text style={styles.tableCell}>Service</Text>
              </View>
              <View style={styles.tableColumns}>
                <Text style={styles.tableCell}>No of Applications</Text>
              </View>
              <View style={styles.tableColumns}>
                <Text style={styles.tableCell}>No of Environment</Text>
              </View>
              <View style={styles.tableColumns}>
                <Text style={styles.tableCell}>{threeweekRange}</Text>
              </View>
              <View style={styles.tableColumns}>
                <Text style={styles.tableCell}>{prePrevWeekRange}</Text>
              </View>
              <View style={styles.tableColumns}>
                <Text style={styles.tableCell}>{prevWeekRange}</Text>
              </View>
              <View style={styles.tableColumns}>
                <Text style={styles.tableCell}>{currentWeekRange}</Text>
              </View>
              <View style={styles.tableColumns}>
                <Text style={styles.tableCell}>
                  Comparison of last two weeks
                </Text>
              </View>
            </View>

            {tableWeeklySpend
              .filter((item) => item.region === region)
              .map((item, dataIndex) => (
                <View
                  style={[
                    styles.tableRow,
                    item.difference > 100 || item.difference < -100
                      ? { backgroundColor: "yellow" } // Change the background color here
                      : null,
                  ]}
                >
                  <View style={styles.tableColleft}>
                    <Text style={styles.tableCellleft}>{item.service}</Text>
                  </View>
                  <View style={styles.tableColright}>
                    <Text style={styles.tableCellright}>
                      {item.no_of_application > 0
                        ? item.no_of_application
                        : "-"}
                    </Text>
                  </View>
                  <View style={styles.tableColright}>
                    <Text style={styles.tableCellright}>
                      {item.no_of_environment > 0
                        ? item.no_of_environment
                        : "-"}
                    </Text>
                  </View>
                  <View style={styles.tableColright}>
                    <Text style={styles.tableCellright}>
                      {" "}
                      {item.fourth_week > 0 || item.fourth_week < 0
                        ? `$${formatNumberWithCommas(item.fourth_week)}`
                        : "-"}
                    </Text>
                  </View>
                  <View style={styles.tableColright}>
                    <Text style={styles.tableCellright}>
                      {" "}
                      {item.pre_previous_week > 0 || item.pre_previous_week < 0
                        ? `$${formatNumberWithCommas(item.pre_previous_week)}`
                        : "-"}
                    </Text>
                  </View>
                  <View style={styles.tableColright}>
                    <Text style={styles.tableCellright}>
                      {" "}
                      {item.previous_week > 0 || item.previous_week < 0
                        ? `$${formatNumberWithCommas(item.previous_week)}`
                        : "-"}
                    </Text>
                  </View>
                  <View style={styles.tableColright}>
                    <Text style={styles.tableCellright}>
                      {" "}
                      {item.current_week > 0 || item.current_week < 0
                        ? `$${formatNumberWithCommas(item.current_week)}`
                        : "-"}
                    </Text>
                  </View>
                  <View style={styles.tableColright}>
                    <Text style={styles.tableCellright}>
                      {" "}
                      {item.difference > 0
                        ? `$${formatNumberWithCommas(item.difference)}`
                        : item.difference < 0
                        ? `-$${formatNumberWithCommas(
                            item.difference.toString().slice(1)
                          )}`
                        : "-"}
                    </Text>
                  </View>
                </View>
              ))}
          </View>
        </View>
      ))}
    </div>
  );
}

export default WeeklySpendByServiceLevel;
